import Loader from '@/components/Loader.tsx';
import MultipleQuestionForm from '@/views/process/components/quizInialized/form/MultipleQuestionForm.tsx';
import OpenQuestionForm from '@/views/process/components/quizInialized/form/OpenQuestionForm.tsx';
import RankQuestionForm from '@/views/process/components/quizInialized/form/RankQuestionForm.tsx';
import ScaleQuestionForm from '@/views/process/components/quizInialized/form/ScaleQuestionForm.tsx';
import SingleQuestionForm from '@/views/process/components/quizInialized/form/SingleQuestionForm.tsx';
import QuestionSegment1 from '@/views/process/components/quizInialized/questions/QuestionSegment1.tsx';
import QuestionSegment2 from '@/views/process/components/quizInialized/questions/QuestionSegment2.tsx';
import QuestionSegment3 from '@/views/process/components/quizInialized/questions/QuestionSegment3.tsx';
import QuestionSegment5 from '@/views/process/components/quizInialized/questions/QuestionSegment5.tsx';
import QuestionSegment6 from '@/views/process/components/quizInialized/questions/QuestionSegment6.tsx';
import QuestionSegment7 from '@/views/process/components/quizInialized/questions/QuestionSegment7.tsx';
import QuestionSegment8 from '@/views/process/components/quizInialized/questions/QuestionSegment8.tsx';
import QuestionSegment9 from '@/views/process/components/quizInialized/questions/QuestionSegment9.tsx';
import QuestionSegment10 from '@/views/process/components/quizInialized/questions/QuestionSegment10.tsx';
import QuestionSegment11 from '@/views/process/components/quizInialized/questions/QuestionSegment11.tsx';
import QuestionSegment12 from '@/views/process/components/quizInialized/questions/QuestionSegment12.tsx';
import QuestionSegment13 from '@/views/process/components/quizInialized/questions/QuestionSegment13.tsx';
import { QuestionSegmentProps } from '@/views/process/components/quizInialized/questions/QuestionSegment.model.ts';
import { FC } from 'react';

export const questionForms = {
  DEFAULT: Loader,
  MULTIPLE: MultipleQuestionForm,
  OPEN: OpenQuestionForm,
  RANK: RankQuestionForm,
  SCALE: ScaleQuestionForm,
  SINGLE: SingleQuestionForm,
};

export const questionSegments: Record<number, FC<QuestionSegmentProps>> = {
  1: QuestionSegment1,
  10: QuestionSegment10,
  11: QuestionSegment11,
  12: QuestionSegment12,
  13: QuestionSegment13,
  2: QuestionSegment2,
  3: QuestionSegment3,
  5: QuestionSegment5,
  6: QuestionSegment6,
  7: QuestionSegment7,
  8: QuestionSegment8,
  9: QuestionSegment9,
};
